export default "__VITE_ASSET__CCk$0VWF__"